<div
  class="item"
  [ngClass]="{ 'item--no-image': !image, vendorItem: isVendorItem }"
>
  <div class="item_image" *ngIf="image">
    <img class="item_image-img" [src]="image" />
  </div>
  <div class="item_detail">
    <div class="item_detail-title" [title]="name">{{ name }}</div>
    <div class="item_detail-chips">
    <app-sku-chip *ngIf="sku"
            [name]="'Sku'"
            [value]="sku"
            (click)="stopPropagation($event)"
             class="item_chip"
    ></app-sku-chip>
    <app-sku-chip
    *ngIf="id"
      [name]="'Id'"
      [value]="id"
      (click)="stopPropagation($event)"
      class="item_chip"
    ></app-sku-chip>
    <app-sku-chip
    *ngIf="asin"
      [name]="'Asin'"
      [value]="asin"
      (click)="stopPropagation($event)"
      class="item_chip"
    ></app-sku-chip>
    <app-sku-chip
    *ngIf="itemName"
      [name]="'Name'"
      [value]="itemName"
      (click)="stopPropagation($event)"
      class="item_chip"
    ></app-sku-chip>
   
    <app-sku-chip *ngIf="account"
            [name]="'Account'"
            [value]="account"
            (click)="stopPropagation($event)"
            class="item_chip"
    ></app-sku-chip>
    <app-sku-chip *ngIf="condition && condition != 'New'"
           [name]="'Condition'" 
           [value]="condition"
           (click)="stopPropagation($event)"
           class="item_chip">
    </app-sku-chip>
  </div>
  </div>
</div>
